import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  children,
  href = 'https://yoga-pro.impultienda.ar/checkout',
  className = '',
  onClick
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (onClick) {
      onClick();
    } else if (href.startsWith('#')) {
      e.preventDefault();
      const targetId = href.substring(1);
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  const baseClasses = `
    inline-flex items-center justify-center w-full
    px-6 py-4 sm:py-5
    font-black text-base sm:text-xl uppercase tracking-wide whitespace-normal text-center leading-tight
    rounded-md
    bg-brand-accent text-white
    hover:bg-[#CC5200] hover:scale-[1.02] hover:shadow-2xl
    transition-all duration-200
    border-b-[6px] border-[#993D00] active:border-b-0 active:translate-y-1.5
    shadow-[0_10px_20px_rgba(230,92,0,0.4)]
    animate-pulse-fast
    ${className}
  `;
  if (href && !href.startsWith('#')) {
    return <a href={href} className={baseClasses} onClick={handleClick} data-id="element-39">
        {children}
      </a>;
  }
  return <button className={baseClasses} onClick={handleClick} data-id="element-40">
      {children}
    </button>;
}